import { defineComponent, ref, useSlots, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, createBlock, resolveDynamicComponent, mergeProps, withCtx, createCommentVNode, normalizeProps, createVNode, toDisplayString, Fragment, renderList, renderSlot } from 'vue';
import _sfc_main$2 from './basler-components.es211.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es134.js';
import { useSlotContent } from './basler-components.es425.js';
import RenderlessComponent from './basler-components.es275.js';

const _hoisted_1 = { class: "nav-secondary__inner" };
const _hoisted_2 = { class: "nav-secondary__header" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["aria-expanded"];
const _hoisted_5 = { class: "visually-hidden" };
const _hoisted_6 = {
  id: "nav-secondary__main-01",
  class: "nav-secondary__main"
};
const _hoisted_7 = { class: "nav-secondary__main-outer" };
const _hoisted_8 = { class: "nav-secondary__main-inner" };
const _hoisted_9 = {
  key: 0,
  class: "nav-secondary__list is-level-01"
};
const _hoisted_10 = { class: "nav-secondary__link-text" };
const _hoisted_11 = {
  key: 1,
  class: "nav-secondary__child-box"
};
const _hoisted_12 = { class: "nav-secondary__list is-level-02" };
const _hoisted_13 = { class: "nav-secondary__link-text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SecondaryNavigation",
  props: {
    title: {},
    titleLink: {},
    openBtnLabel: { default: "Open navigation" },
    items: {}
  },
  emits: ["navigate"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const isOpen = ref(false);
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasCtaSlotContent = computed(() => {
      return hasSlotContent(slots.cta);
    });
    const onLinkClicked = (event, navigate, link) => {
      isOpen.value = false;
      if (link) {
        emit("navigate", link);
      }
      navigate(event);
    };
    const onCtaClick = () => {
      isOpen.value = false;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", {
        class: normalizeClass(["nav-secondary", { "is-open": isOpen.value }])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            (openBlock(), createBlock(resolveDynamicComponent(_ctx.titleLink ? _sfc_main$1 : RenderlessComponent), mergeProps(
              _ctx.titleLink ? { ..._ctx.titleLink, onClick: (event, navigate) => onLinkClicked(event, navigate, _ctx.titleLink) } : void 0,
              { class: "nav-secondary__headline-link" }
            ), {
              default: withCtx(() => [
                _ctx.title ? (openBlock(), createBlock(_sfc_main$2, normalizeProps(mergeProps({ key: 0 }, { ..._ctx.title, content: void 0 })), {
                  default: withCtx(() => [
                    _ctx.title?.content ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      innerHTML: _ctx.title.content
                    }, null, 8, _hoisted_3)) : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 16)) : createCommentVNode("", true)
              ]),
              _: 1
            }, 16)),
            createElementVNode("button", {
              class: "nav-secondary__trigger-btn",
              "aria-expanded": isOpen.value,
              "aria-controls": "nav-secondary__main-01",
              onClick: _cache[0] || (_cache[0] = ($event) => isOpen.value = !isOpen.value)
            }, [
              createVNode(_sfc_main$3, { name: "arrow-down-bold" }),
              createElementVNode("span", _hoisted_5, toDisplayString(_ctx.openBtnLabel), 1)
            ], 8, _hoisted_4)
          ]),
          createElementVNode("div", _hoisted_6, [
            createElementVNode("div", _hoisted_7, [
              createElementVNode("div", _hoisted_8, [
                _ctx.items ? (openBlock(), createElementBlock("ul", _hoisted_9, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (itemLvl01) => {
                    return openBlock(), createElementBlock("li", {
                      key: itemLvl01.text,
                      class: "nav-secondary__list-item is-level-01"
                    }, [
                      itemLvl01?.link ? (openBlock(), createBlock(_sfc_main$1, mergeProps({
                        key: 0,
                        ref_for: true
                      }, itemLvl01.link, {
                        class: ["nav-secondary__link is-level-01", { "is-active": itemLvl01.isActive }],
                        onClick: (event, navigate) => onLinkClicked(event, navigate, itemLvl01.link)
                      }), {
                        default: withCtx(() => [
                          createElementVNode("span", _hoisted_10, toDisplayString(itemLvl01.text), 1),
                          itemLvl01?.items ? (openBlock(), createBlock(_sfc_main$3, {
                            key: 0,
                            name: "arrow-down-bold"
                          })) : createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1040, ["class", "onClick"])) : createCommentVNode("", true),
                      itemLvl01?.items ? (openBlock(), createElementBlock("div", _hoisted_11, [
                        createElementVNode("ul", _hoisted_12, [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(itemLvl01.items, (itemLvl02) => {
                            return openBlock(), createElementBlock("li", {
                              key: itemLvl02.text,
                              class: "nav-secondary__list-item is-level-02"
                            }, [
                              itemLvl02?.link ? (openBlock(), createBlock(_sfc_main$1, mergeProps({
                                key: 0,
                                ref_for: true
                              }, itemLvl02.link, {
                                class: ["nav-secondary__link is-level-02", { "is-active": itemLvl02.isActive }],
                                onClick: (event, navigate) => onLinkClicked(event, navigate, itemLvl02.link)
                              }), {
                                default: withCtx(() => [
                                  createElementVNode("span", _hoisted_13, toDisplayString(itemLvl02.text), 1)
                                ]),
                                _: 2
                              }, 1040, ["class", "onClick"])) : createCommentVNode("", true)
                            ]);
                          }), 128))
                        ])
                      ])) : createCommentVNode("", true)
                    ]);
                  }), 128))
                ])) : createCommentVNode("", true),
                hasCtaSlotContent.value ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: "nav-secondary__cta-box",
                  onClick: onCtaClick
                }, [
                  renderSlot(_ctx.$slots, "cta")
                ])) : createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
